import Toast, { type PluginOptions } from 'vue-toastification'

export default defineNuxtPlugin(({ vueApp }) => {
  const options: PluginOptions = {
    // You can set your default options here
  }
  // TODO update to fox warning: https://github.com/Maronato/vue-toastification/issues/341
  vueApp.use(Toast, options)
})
